<template>
  <button
    :aria-controls="disclosureId"
    :aria-expanded="expanded.toString()"
    @click="maybeExpanded"
  >
    <slot />
  </button>
</template>

<script>
import eventBus from '@/js/util/EventBus'

export default {
  props: {
    happensOnce: {
      type: Boolean,
      default: false,
    },
    disclosureId: {
      type: String,
      required: true,
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      once: false,
      expanded: this.initiallyExpanded,
    }
  },
  watch: {
    expanded() {
      eventBus.$emit('toggle', {
        expanded: this.expanded,
        controls: this.disclosureId,
      })
    },
  },
  created() {
    eventBus.$on('force:close', () => {
      this.toggleExpanded(false)
    })
    eventBus.$on('created:container', this.createdContainer)
  },
  methods: {
    toggleExpanded(expanded = !this.expanded) {
      this.expanded = expanded
    },
    maybeExpanded() {
      if (!this.happensOnce) {
        this.toggleExpanded()
        return
      }

      this.expanded = true
    },
    createdContainer(disclosureId) {
      eventBus.$emit('toggle', {
        expanded: this.expanded,
        controls: disclosureId,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/disclosure/DisclosureButton.vue